"use client";
import React, { memo } from "react";
import UserInfo from "../UserInfo";
import MegaMenu from "@/components/Header/MegaMenu";
import { Box, Row, Columns } from "@dxp-feed/ui";
import { SiteContainer } from "../../Container";
import UserPoints from "../UserPoints";

const HeaderTopSection = ({
  headerData,
  setIsPanelOpen,
  mobileMedia,
  isSearchQuery,
  isHomePage,
}: any) => {
  return (
    <>
      <Box
        as="div"
        className={`top-header mb:pb-[12px] py-1 hidden lg:block bg-brandWhite border-b-[1px] border-grey350
// ${isSearchQuery || !isHomePage ? "border-b-[1px] border-grey350" : ""}`}
      >
        <SiteContainer className="px-6 2md:px-12 !max-w-[1536px]">
          <Row>
            <Columns className="col-9 flex items-center">
              <Box className="">
                <MegaMenu
                  headerData={headerData["navigation_879072575"]}
                  setIsPanelOpen={setIsPanelOpen}
                />
              </Box>
            </Columns>
            <Columns className="col-3 gap-2 flex justify-end">
              <Box
                as="div"
                className="header-nav-user gap-[4px] flex items-center ml-auto"
              >
                {mobileMedia && mobileMedia >= 1024 && (
                  <>
                    <UserInfo />
                    <UserPoints />
                  </>
                )}
              </Box>
            </Columns>
          </Row>
        </SiteContainer>
      </Box>
    </>
  );
};

export default memo(HeaderTopSection);
